const HOLDINGS_PAGE_LIMIT = 10

export const portfolioKeys = {
  all: ['portfolio'] as const,
  overview: () => [...portfolioKeys.all, 'overview'] as const,
  rentalIncomeSummary: () => [...portfolioKeys.all, 'rentalIncomeSummary'] as const,
  graph: (type: 'value' | 'rental') => [...portfolioKeys.all, 'graph', type] as const,
  holdings: () => [...portfolioKeys.all, 'holdings', 'list'] as const,
  investmentDetails: () => [...portfolioKeys.all, 'investmentDetail'] as const,
  investmentDetail: (id: string) => [...portfolioKeys.investmentDetails(), id] as const,
}

export { HOLDINGS_PAGE_LIMIT }
